import React, { FunctionComponent } from 'react';
import { ActionButtonsDisplayConfig } from '../ActionButtonsContainer';
import CheckoutLiteReserveOnlineButtonContainer from './CheckoutLiteReserveOnlineButtonContainer';
import ProceedToBasketButtonContainer from './ProceedToBasketButtonContainer';
import SubmitCarToUrlButtonContainer from './SubmitCarToUrlButtonContainer';
import IActionButtonProps from '../IActionButtonProps';

function isSubmitToCarSubmissionUrl(config: ActionButtonsDisplayConfig): boolean {
  return !!config.carSubmissionURL;
}

function isSubmitRedirectToBasket(config: ActionButtonsDisplayConfig): boolean {
  return !!config.basketUrl;
}

function isSubmitToEnquiryFormOnCheckoutLite(config: ActionButtonsDisplayConfig): boolean {
  return !!(config.isCheckoutLiteEnabled && config.requestQuoteUrl);
}

const SubmitContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  if (isSubmitToEnquiryFormOnCheckoutLite(config)) {
    return <CheckoutLiteReserveOnlineButtonContainer config={config} />;
  }

  if (isSubmitToCarSubmissionUrl(config)) {
    return <SubmitCarToUrlButtonContainer config={config} />;
  }

  // This needs to be last, because we always have basketUrl.
  if (isSubmitRedirectToBasket(config)) {
    return <ProceedToBasketButtonContainer config={config} />;
  }

  return <></>;
};

export default SubmitContainer;
